import { Box } from "@mui/material";
import { ExplorerError } from "../../../models/Explorer";
import ErrorCard from "../../Elements/ErrorCard";
import { formatSeasonLabel } from "../../Elements/QueryResultNotices/QueryResultNotices";

interface ExplorerErrorCardProps {
  error: ExplorerError;
}

/**
 * The seasons of this query an item can run on, for a `mixed_source_native`
 * refusal. The backend message already says "Narrow the seasons or set a
 * source"; this names the seasons without naming a provider.
 */
export function sourceErrorDetail(error: ExplorerError): string | undefined {
  const details = error.details ?? {};
  if (error.errorType === "mixed_source_native") {
    const itemSources: string[] = Array.isArray(details.itemSources)
      ? details.itemSources
      : [];
    const bySource: Record<string, number[]> = details.seasonsBySource ?? {};
    const seasons = itemSources
      .flatMap((s) => bySource[s] ?? [])
      .sort((a, b) => a - b);
    if (seasons.length === 0) return undefined;
    const label = seasons.map(formatSeasonLabel).join(", ");
    return `${details.item ?? "This item"} is available for ${label} in this query.`;
  }
  return undefined;
}

export default function ExplorerErrorCard({ error }: ExplorerErrorCardProps) {
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 10,
        backdropFilter: "blur(1px)",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
      }}
    >
      <ErrorCard
        title="Query Error"
        message={error.message}
        detail={sourceErrorDetail(error)}
      />
    </Box>
  );
}
